import React from 'react';
import Nav from 'react-bootstrap/Nav';
import { useForceUpdate } from './util';
const DEBUG = false;
const TabContext = /*#__PURE__*/React.createContext({
  stateRef: {},
  activeTab: 0,
  onTabsChange: null
});
export function TabContextProvider({
  children,
  activeTab,
  onChange,
  onTabsChange,
  noTabs
}) {
  const forceUpdate = useForceUpdate();
  const [stab, ssetTab] = React.useState(0);
  const [tab, setTab] = activeTab === undefined ? [stab, ssetTab] : [activeTab, onChange];
  //const actualTab = activeTab ?? tab
  const value = React.useMemo(() => {
    DEBUG && console.log("TabContextProvider value memo", tab);
    return {
      stateRef: {},
      activeTab: tab,
      onTabsChange: onTabsChange
    };
  }, [tab]);
  React.useEffect(() => {
    DEBUG && console.log("TabContext Value changed", Object.keys(value.stateRef).map(k => `${k}: ${value.stateRef[k]}`).join(", "));
    DEBUG && console.log("TabContext current:", value.stateRef[value.activeTab]);
    if (!Object.keys(value.stateRef).includes("" + value.activeTab) && !Object.keys(value.stateRef).includes("" + tab) && Object.keys(value.stateRef).length > 0) {
      let newtab = Object.keys(value.stateRef).sort()[0];
      newtab = isNaN(Number(newtab)) ? newtab : Number(newtab);
      DEBUG && console.log("TabContext switching to valid tab", newtab);
      setTab(newtab);
      return;
    }
    if (onTabsChange !== undefined) {
      onTabsChange(value.stateRef);
    }
    /*
    forceUpdate()
    */
  }, [value]);
  return /*#__PURE__*/React.createElement(TabContext.Provider, {
    value: value
  }, !noTabs && /*#__PURE__*/React.createElement(Nav, {
    variant: "pills",
    className: "flex-column"
  }, Object.keys(value.stateRef).sort().map(i => {
    i = isNaN(Number(i)) ? i : Number(i);
    const v = value.stateRef[i];
    return /*#__PURE__*/React.createElement(Nav.Link, {
      active: tab === i,
      onClick: () => setTab(i)
    }, v);
  })), children);
}
export function TabContextReporter({
  title,
  index,
  children,
  onShow
}) {
  let {
    stateRef,
    activeTab,
    onTabsChange
  } = React.useContext(TabContext);
  index = isNaN(Number(index)) ? index : Number(index);
  stateRef[index] = title;
  React.useEffect(() => {
    if (activeTab == index && onShow) {
      onShow();
    }
    return () => {
      delete stateRef[index];
      onTabsChange(stateRef);
    };
  }, [activeTab]);
  DEBUG && console.log("TabContextReporter", activeTab, index, activeTab === index, activeTab == index);
  return /*#__PURE__*/React.createElement("div", {
    style: {
      display: activeTab == index ? 'block' : 'none'
    }
  }, activeTab == index ? children : null /*children*/);
}